import {
  AnimationMetadata,
  animate,
  style,
  transition,
  trigger,
} from '@angular/animations';

interface CountryPrefixSelectAnimations {
  panelOpen: AnimationMetadata;
}

export const countryPrefixSelectAnimations: CountryPrefixSelectAnimations = {
  panelOpen: trigger('panelOpen', [
    transition(':enter', [
      style({ opacity: 0, transform: 'scaleY(0.8)' }),
      animate(
        '120ms cubic-bezier(0, 0, 0.2, 1)',
        style({ opacity: 100, transform: 'scaleY(1)' }),
      ),
    ]),
  ]),
};
